import React, { useState, useEffect } from 'react'
import { FormGroup, ControlLabel, FormControl, Radio, RadioGroup } from 'rsuite'
import classNames from 'classnames'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
// import './styles.less'

export default function SingleRadioForm({
  schema: _schema,
  register,
  error,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
}) {
  const [schema, setSchema] = useState(_schema)

  return (
    <>
      <ErrorMessage error={error} />
      <Controller
        name={schema.name}
        control={control}
        defaultValue={schema.value || '1'}
        rules={isValidators(schema.validators)}
        render={(props) => {
          return (
            <RadioGroup
              value={props.value}
              onChange={(value) => {
                props.onChange(value)
              }}
            >
              {schema.options.map((item) => (
                <Radio key={item.value} value={item.value} disabled={schema.disabled}>
                  {item.label}
                </Radio>
              ))}
            </RadioGroup>
          )
        }}
      />
    </>
  )
}
